import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { flight_dateTimeFormat } from "../../pages/Home";
import ReturnFilter from "./ReturnFilter";

const ReturnFlightResult = () => {

  const dispatch = useDispatch();
  const flight_data = useSelector((state) => state.global.flights_list);
  const calender_fare = useSelector((state) => state.global.calender_fare);
  const search_data = useSelector((state) => state.global.search_data);
  const filter_data = useSelector((state) => state.global.search_filters);
  return (
    <>
      <Card.Header>
        <div className="row">
          <div className="col-lg-2 col-sm-12 col-5">1. Flight Search </div>
          <div className="col-lg-2 col-sm-12 col-5">2. Flight Result</div>
          <div className="col-lg-2 col-sm-12 col-6">3. Passenger Details</div>
          <div className="col-lg-2 col-sm-12 col-6">4. Review Booking</div>
          <div className="col-lg-2 col-sm-12 col-7">
            5. Booking Confirmation
          </div>
        </div>
      </Card.Header>
      <div className="">
        <div class="card-header">
          <div class="row">
            <div class="col-lg-2">Your Search Criteria</div>
            <div class="col-lg-10">
              {flight_data.status && flight_data.Origin}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-arrow-right-short"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                />
              </svg>
              {/* Dept : Mon, 17 Jan 2022 1 Adult(s) */}
              {flight_data.status && flight_data.Destination} {`Dept : ${flight_dateTimeFormat(
                                      flight_data.status && flight_data['Results'][0][0]['Segments'][0][0]['Origin'].DepTime,
                                      true
              )}`}
            </div>
          </div>
        </div>
        {/* <div className="container">
          <div class="row">
            <div class="col-lg-2">
              <button type="button" class="btn btn-secondary">
                Normal Return
              </button>
            </div>
            <div class="col-lg-2">
              <button type="button" class="btn btn-secondary">
                LCC Special Return
              </button>
            </div>
            <div class="col-lg-2">
              <button type="button" class="btn btn-secondary">
                GDS Special Return
              </button>
            </div>
          </div>
        </div> */}
        <ReturnFilter />
      </div>
    </>
  );
};
export default ReturnFlightResult;
